import store from '../../store';

// 控制台域名地址
export function domainOfConsole(options = { hasBaseUrl: true, protocol: true }) {
  // VUE_APP_WEB_URL=https://test01.e.vhall.com/v3
  let url =
    store.state.customDomain?.status == 1 && store.state.customDomain?.console_domain
      ? `${store.state.customDomain.console_domain}/v3`
      : process.env.VUE_APP_ROOM_WATCH;
  url = url.toLocaleLowerCase();
  if (!options?.hasBaseUrl) url = url.replace('/v3', '');
  if (!options?.protocol) url = url.replace('http://', '').replace('https://', '');
  return url;
}

// 发起端域名地址
export function domainOfLive(options = { hasBaseUrl: true, protocol: true }) {
  // VUE_APP_ROOM_WATCH=https://test01.e.vhall.com/v3
  let url =
    store.state.customDomain?.status == 1 && store.state.customDomain?.console_domain
      ? `${store.state.customDomain.console_domain}/v3`
      : process.env.VUE_APP_ROOM_WATCH;
  url = url.toLocaleLowerCase();
  if (!options?.hasBaseUrl) url = url.replace('/v3', '');
  if (!options?.protocol) url = url.replace('http://', '').replace('https://', '');
  return url;
}

// 观看端域名地址
export function domainOfWatch(options = { hasBaseUrl: true, protocol: true }) {
  // VUE_APP_WAP_WATCH=https://test01-live.vhall.com/v3
  let url =
    store.state.customDomain?.status == 1 && store.state.customDomain?.watch_domain
      ? `${store.state.customDomain.watch_domain}/v3`
      : process.env.VUE_APP_WAP_WATCH;
  url = url.toLocaleLowerCase();
  if (!options?.hasBaseUrl) url = url.replace('/v3', '');
  if (!options?.protocol) url = url.replace('http://', '').replace('https://', '');
  return url;
}
